import React from 'react';

import {
    SearchCardInformationHierarchyExperimentConfig,
    SearchServerEnrolledExperiments,
} from '../../types/Experiments';

export const OVERRIDE_KEY = 'overrideStatsigServerEnroll';

function getExperimentEnrollments(
    enrollments: SearchServerEnrolledExperiments = {},
    overrides?: URLSearchParams,
): SearchServerEnrolledExperiments {
    let overwritten: SearchServerEnrolledExperiments = enrollments;

    if (overrides && overrides.has(OVERRIDE_KEY)) {
        const [experimentName, key, val] =
            overrides.get(OVERRIDE_KEY)?.split(':') || [];
        overwritten = {
            ...overwritten,
            [experimentName]: { [key]: val },
        };
    }

    return overwritten;
}

export const useGetSearchInformationCardHierarchyType = () => {
    const serverEnrolledValues = useSearchServerEnrolledExperiment();

    return serverEnrolledValues[
        SearchCardInformationHierarchyExperimentConfig.name
    ]?.[SearchCardInformationHierarchyExperimentConfig.paramName];
};

const SearchServerEnrolledExperimentContext =
    React.createContext<Partial<SearchServerEnrolledExperiments> | null>(null);

export const useSearchServerEnrolledExperiment = () => {
    const value = React.useContext(SearchServerEnrolledExperimentContext);

    if (!value) {
        throw new Error(
            '`useSearchServerEnrolledExperiment` must be used within a `SearchServerEnrolledExperimentProvider`',
        );
    }

    return value;
};

interface SearchServerEnrolledExperimentProviderProps {
    experimentEnrollments?: SearchServerEnrolledExperiments;
    experimentEnrollmentOverrides?: URLSearchParams;
}

export const SearchServerEnrolledExperimentProvider: React.FunctionComponent<
    SearchServerEnrolledExperimentProviderProps
> = (props) => {
    const [serverEnrolledExperiment] = React.useState(() =>
        getExperimentEnrollments(
            props.experimentEnrollments,
            props.experimentEnrollmentOverrides,
        ),
    );

    return (
        <SearchServerEnrolledExperimentContext.Provider
            value={serverEnrolledExperiment}
        >
            {props.children}
        </SearchServerEnrolledExperimentContext.Provider>
    );
};

/**
 * Add custom hooks here to make getting enrollment status of a given
 * experiment more straightforward for consumers.
 */
